<template>
  <el-header :class="classComputed" :height="heightComputed">
    <el-row
      ref="content"
      type="flex"
      align="start"
      :class="contentClass"
      justify="start"
      :style="{ height: contentHeight + 'px' }"
    >
      <slot></slot>
    </el-row>
    <div class="tg-toolbar--extension" ref="extension" v-if="!!$scopedSlots.extension">
      <slot name="extension"></slot>
    </div>
  </el-header>
</template>

<script>
import { toolProps } from "./utils";
export default {
  name: "TgToolbar",
  props: toolProps,
  data() {
    return {
      extendHeight: 0
    };
  },
  mounted() {
    this.parseExtendheight();
  },
  computed: {
    classComputed() {
      return ["tg-toolbar", "tg-toolbar--size-" + this.size];
    },
    contentClass() {
      return ["tg-toolbar--content"];
    },
    heightComputed() {
      let height = this.contentHeight + this.extendHeight;

      if (this.floating) {
        height += 24;
      }

      return height + "px";
    },
    contentHeight() {
      let height = this.height;

      if (this.prominent) {
        height = 84;
      } else {
        switch (this.size) {
          case "float":
            height = 160;
            break;
          case "large":
            height = 128;
            break;
          case "small":
            height = 48;
            break;
          default:
            height = 56;
            break;
        }
      }
      return height;
    }
  },
  methods: {
    parseExtendheight() {
      this.extendHeight = this.$refs.extension.clientHeight;
    }
  },
};
</script>
